var _rect, _circle, _path, _path2, _path3, _path4, _path5, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 16,
    fill: "url(#paint0_linear_119_4227)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 47.7887,
    stroke: "black",
    strokeWidth: 30.4225
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M90.874 37.125C120.076 37.125 143.749 60.5461 143.749 89.4375C143.749 118.329 120.076 141.75 90.874 141.75",
    stroke: "#F1F5F9",
    strokeWidth: 0.450704
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.3686 88.8751C51.3686 67.6449 68.5791 50.4344 89.8093 50.4344C111.04 50.4344 128.25 67.6449 128.25 88.8751",
    stroke: "#F1F5F9",
    strokeWidth: 0.450704
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M131.625 90C131.625 112.989 112.989 131.625 90 131.625C67.0111 131.625 48.375 112.989 48.375 90",
    stroke: "#F1F5F9",
    strokeWidth: 0.450704
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.3829 106.767C37.7586 82.7032 49.4641 55.3937 73.5278 45.7694C97.5916 36.1451 124.901 47.8506 134.525 71.9143",
    stroke: "#F1F5F9",
    strokeWidth: 0.450704
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.339 90.1695C124.339 109.041 109.041 124.339 90.1695 124.339C71.2982 124.339 56 109.041 56 90.1695C56 71.2982 71.2982 56 90.1695 56C109.041 56 124.339 71.2982 124.339 90.1695Z",
    fill: "url(#paint1_radial_119_4227)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.5,
    cy: 90.5,
    r: 18.5,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_119_4227",
    x1: 3.51562,
    y1: -152.5,
    x2: 195.541,
    y2: -111.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3B3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_119_4227",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.1695 90.1695) rotate(90) scale(34.1695)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4DCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6BAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLp);
export default __webpack_public_path__ + "static/media/lp.3934e3cbaa57d62785353ac6484be794.svg";
export { ForwardRef as ReactComponent };